export default __webpack_public_path__ + "d8.png";